import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TimelineSection() {
  const timelineArticles = articles.slice().sort((a, b) =>
    new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-xs font-semibold tracking-widest uppercase text-secondary-500">REAL-TIME FEED</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
              最新爆料追踪
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-lg">
              按时间线追踪每一个热点事件，不错过任何爆料细节
            </p>
          </div>
          <Link
            to="/category/meiri-baoliao"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="absolute left-[19px] top-2 bottom-2 w-[2px] bg-background-200 hidden md:block" />

          <div className="space-y-8 md:space-y-10">
            {timelineArticles.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex flex-col md:flex-row gap-4 md:gap-8 relative cursor-pointer"
              >
                <div className="hidden md:flex flex-col items-center flex-shrink-0 pt-1 z-10">
                  <div className="w-[40px] h-[40px] rounded-full bg-background-50 border-2 border-primary-200 group-hover:border-primary-500 flex items-center justify-center transition-colors duration-300">
                    <span className="text-xs font-bold text-primary-500">{index + 1}</span>
                  </div>
                </div>

                <div className="flex-1 bg-background-50 rounded-2xl border border-background-200/70 group-hover:border-primary-100 transition-all duration-300 overflow-hidden flex flex-col md:flex-row">
                  <div className="w-full md:w-[180px] aspect-[16/10] md:aspect-[3/2] overflow-hidden bg-secondary-100 flex-shrink-0">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={article.title}
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="inline-block px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-500">{article.publishDate}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1.5 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line" />
                        {(article.readCount / 10000).toFixed(1)}万
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line" />
                        {article.commentCount}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}